import React, { Component } from "react";
import { Alert, Button, Table, Spinner } from "react-bootstrap";

class LddDescription extends Component {
    constructor() {
        super();

    }

    render() {
        return (
            <Alert style={{ width: '100%', cursor: 'pointer', }} >
                <div onClick={this.props.blockLddDescriptionIsOpen ? this.props.closeBlockLddDescription : this.props.openBlockLddDescription}
                    style={{ display: "flex", borderBottom: this.props.blockLddDescriptionIsOpen ? "1px solid #e3e3e3" : null, height: this.props.blockLddDescriptionIsOpen ? "40px" : null /*cursor: "pointer"*/ }}>
                    <div style={{ width: "55%" }}>
                        <div style={{ color: "black" }}>&bull; LDD Client </div>

                    </div>
                    <div style={{ width: "45%" }}>
                        <b style={{ color: "black", float: "right" }}>
                            {this.props.blockLddDescriptionIsOpen ?
                                <div >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                </div> :
                                <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                            }
                        </b>
                    </div>

                </div>
                {
                    this.props.blockLddDescriptionIsOpen ? <div style={{ color: "black" }}>
                        LWO Digital Defense Client предназначен для обеспечения возможности
                        взаимодействия с функциями программного комплекса криптографической защиты информации
                        «LWO Crypt» через сетевую архитектуру REST API с использованием протокола HTTPS.
                        LDD предоставляет пользователю графический интерфейс для доступа к основным
                        функциям ПК LWOCRYPT.
                        Перечень доступных в графическом интерфейсе LDD функций ПК LWOCRYPT:
                        <ul>
                            <li>
                                генерация пары ключей;
                            </li>
                            <li>
                                генерация запроса на получение сертификата;
                            </li>
                            <li>
                                выработка электронной цифровой подписи;
                            </li>
                            <li>
                                проверка электронной цифровой подписи;
                            </li>
                            <li>
                                хэширование;
                            </li>
                            <li>
                                работа с ID-картой.
                            </li>
                        </ul>

                    </div> : null
                }

            </Alert>
        );
    }
}

export default LddDescription;
